/* Client-side Segment event names.

Naming convention: {domain}_{object}_{action}
Keep the enum in alphabetical order.

OWNERSHIP NOTE — avoid double-counting:
  Backend mutations fire: document_uploaded, document_moved_to_folder, folder_created.
  Frontend fires only UI-interaction events the backend cannot observe.
*/
export var TrackingEventNames = /*#__PURE__*/function (TrackingEventNames) {
  TrackingEventNames["COSTAR_AUTHENTICATION_COMPLETED"] = "costar_authentication_completed";
  TrackingEventNames["COSTAR_AUTHENTICATION_INITIATED"] = "costar_authentication_initiated";
  TrackingEventNames["COSTAR_IMPORT_INITIATED"] = "costar_import_initiated";
  TrackingEventNames["COSTAR_IMPORT_STEP1_VIEWED"] = "costar_import_step_auth_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP2_VIEWED"] = "costar_import_step_select_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP3_VIEWED"] = "costar_import_step_import_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP4_VIEWED"] = "costar_import_step_preview_viewed";
  TrackingEventNames["COSTAR_IMPORT_VIEW_LISTINGS_CLICKED"] = "costar_import_view_listings_clicked";
  TrackingEventNames["COSTAR_SURVEY_SELECTED"] = "costar_survey_selected";
  TrackingEventNames["COSTAR_SURVEY_UNSELECTED"] = "costar_survey_unselected";
  TrackingEventNames["COSTAR_WIZARD_OPENED"] = "costar_wizard_opened";
  TrackingEventNames["COSTAR_WIZARD_STEP_TRANSITION_CLICKED"] = "costar_wizard_step_transition_clicked";
  TrackingEventNames["CURRENT_LOCATION_EDIT_CANCELLED"] = "current_location_edit_cancelled";
  TrackingEventNames["CURRENT_LOCATION_EDIT_CLICKED"] = "current_location_edit_clicked";
  TrackingEventNames["ELEMENT_PRESSED"] = "element pressed";
  TrackingEventNames["FOLDER_SELECTED_DURING_UPLOAD"] = "folder_selected_during_upload";
  TrackingEventNames["LEASE_NAME_SEARCHED"] = "lease_name_searched";
  TrackingEventNames["MOVE_TO_INITIATED"] = "move_to_initiated";
  TrackingEventNames["TRANSACTION_CLONE_CANCELLED"] = "transaction_clone_cancelled";
  TrackingEventNames["TRANSACTION_CLONE_CLICKED"] = "transaction_clone_clicked";
  TrackingEventNames["TRANSACTION_CLONE_COMPLETED"] = "transaction_clone_completed";
  TrackingEventNames["TRANSACTION_FIELD_EDITED"] = "transaction field edited";
  TrackingEventNames["TRANSACTION_TABLE_EDIT_CLICKED"] = "transaction table edit clicked";
  TrackingEventNames["TRANSACTION_TABLE_SAVE_COMPLETED"] = "transaction table save completed";
  return TrackingEventNames;
}({});

// Legacy: Used with trackEvent() (e.g. ELEMENT_PRESSED + pageView/context).
// All events show up as ELEMENT_PRESSED in Segment.
// For NEW tracking, prefer adding a specific event name to TrackingEventNames
// Make sure these are in alphabetical order
export var TrackingEventPageView = /*#__PURE__*/function (TrackingEventPageView) {
  TrackingEventPageView["BROKER_DEALROOM_NEW_DEAL"] = "broker dealroom new deal";
  TrackingEventPageView["BROKER_DEALROOM_OVERVIEW"] = "broker dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_LISTINGS"] = "client dealroom listings";
  TrackingEventPageView["CLIENT_DEALROOM_OVERVIEW"] = "client dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_PROPOSALS"] = "client dealroom proposals";
  TrackingEventPageView["CLIENT_DEALROOM_TOURS"] = "client dealroom tours";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_ACTIVE_LEASES"] = "portfolio management active leases";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_DOCUMENTS"] = "portfolio management documents";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_LEASE_DETAILS"] = "portfolio management lease details";
  return TrackingEventPageView;
}({});

// Legacy: Used with trackEvent() (e.g. ELEMENT_PRESSED + pageView/context).
// All events show up as ELEMENT_PRESSED in Segment.
// For NEW tracking, prefer adding a specific event name to TrackingEventNames
// Make sure these are in alphabetical order
export var TrackingEventContext = /*#__PURE__*/function (TrackingEventContext) {
  TrackingEventContext["ADD_NOTE"] = "add note";
  TrackingEventContext["ADD_OCCUPANCY"] = "add occupancy";
  TrackingEventContext["ADD_OUTREACH"] = "add outreach";
  TrackingEventContext["ADD_REMINDER"] = "add reminder";
  TrackingEventContext["ADD_TO_CALENDAR"] = "add to calendar";
  TrackingEventContext["BACK_TO_LISTINGS"] = "back to listings";
  TrackingEventContext["CAROUSEL_ARROWS"] = "carousel arrows";
  TrackingEventContext["CATEGORY_PILL"] = "category pill";
  TrackingEventContext["COMPARED_LISTINGS"] = "compared listings";
  TrackingEventContext["COPY_LINK"] = "copy link";
  TrackingEventContext["CREATE_NOTE"] = "create note";
  TrackingEventContext["CREATE_OUTREACH"] = "create outreach";
  TrackingEventContext["CREATE_REMINDER"] = "create reminder";
  TrackingEventContext["DEAL_PHASE_UPDATE"] = "deal phase update";
  TrackingEventContext["DEALROOM_VISIBLE"] = "dealroom visible";
  TrackingEventContext["DEFAULT_BROKER"] = "default broker";
  TrackingEventContext["DISLIKED_LISTING"] = "disliked listing";
  TrackingEventContext["DOCUMENT_ADDED_COMMENT"] = "document added comment";
  TrackingEventContext["DOCUMENT_FILE_NAME"] = "document file name";
  TrackingEventContext["DOWNLOAD_DOCUMENT"] = "download document";
  TrackingEventContext["EDIT_CLIENT_REQUIREMENTS"] = "edit client requirements";
  TrackingEventContext["EDIT_DEAL_SUMMARY"] = "edit deal summary";
  TrackingEventContext["EXECUTE_DEAL"] = "execute deal";
  TrackingEventContext["FILTER_PILL"] = "filter pill";
  TrackingEventContext["LEASE_DETAILS"] = "lease details";
  TrackingEventContext["LIKED_LISTING"] = "liked listing";
  TrackingEventContext["LISTING_CARD"] = "listing card";
  TrackingEventContext["LISTING_DETAILS"] = "listing details";
  TrackingEventContext["MAP_LISTING_DETAILS"] = "map listing details";
  TrackingEventContext["MARK_DEAL_AS_LOST"] = "mark deal as lost";
  TrackingEventContext["MOVE_TO_PURSUITS"] = "move to pursuits";
  TrackingEventContext["NEW_DOCUMENT"] = "new document";
  TrackingEventContext["NEW_FOLDER"] = "new folder";
  TrackingEventContext["NEW_LISTING_THUMBNAIL"] = "new listing thumbnail";
  TrackingEventContext["OPEN_EMAILER"] = "open emailer";
  TrackingEventContext["PAST_TOUR"] = "past tour";
  TrackingEventContext["RESET_DEALROOM"] = "reset dealroom";
  TrackingEventContext["REVERSE_SORT_LISTINGS"] = "reverse sort listings";
  TrackingEventContext["SAVE_CLIENT_REQUIREMENTS"] = "save client requirements";
  TrackingEventContext["SAVE_DEAL"] = "save deal";
  TrackingEventContext["SAVE_DEAL_SUMMARY"] = "save deal summary";
  TrackingEventContext["SAVE_FILTER"] = "save filter";
  TrackingEventContext["SHARE_BUTTON"] = "share button";
  TrackingEventContext["SORT_LISTINGS"] = "sort listings";
  TrackingEventContext["TOUR_DETAILS"] = "tour details";
  TrackingEventContext["TOUR_REQUESTED"] = "tour requested";
  TrackingEventContext["UPCOMING_TOUR"] = "upcoming tour";
  TrackingEventContext["VIEW_ALL_CRITICAL_DATES"] = "view all critical dates";
  TrackingEventContext["VIEW_LISTINGS"] = "view listings";
  TrackingEventContext["VIEW_PROPOSAL"] = "view proposal";
  return TrackingEventContext;
}({});